import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CMSPath, CLICKED, EXIT } from '../../../../config/constant'
import { setFailScreen } from '../../../../action/action'
import { VDAsendCommand } from '../../../../action/roomControlAction'
import { roomThemeColorConfig, clearConfig } from '../../../JS/colorConfig'
import { scrollUpEffect, scrollDownEffect, removeScrollDown } from '../scrollEffect';
import { dynamicHeight } from '../../../JS/listItemHeightFix';
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../../JS/utility'
import { sendAnalytics } from "../../../../action/homeAction";
import { setGoHome, setLoader } from '../../../action/homeAction'
import { closeOrderPopUp } from '../../../action/hCommerce2'
import { PowerIcon } from './MultiController'
import Loader from '../../../UI/loader'

class RoomTheme extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentLightscene: null,
      widgetLaunchTime: new Date,
      widgetName: this.props.currentWidget.displayName
    }

    this.appBodyPaddBottom = null;
    
  }

  componentDidUpdate() {
    roomThemeColorConfig(this.props.menuColor);
    dynamicHeight();
  }

  componentDidMount(){
    dynamicHeight();
  }

  goBack = (event) => {
    if(event) event.preventDefault();
      window.history.back();
  }

  selectLightScene = (id, mode, lightScreen) => {
    const statusCallback=(status)=>{
      this.props.setLoader(false);
      if (status) {
        this.props.closeOrderPopUp(true, `Request sent successfully`, "", false);
      } else { 
        this.props.closeOrderPopUp(true,`Something went wrong while sending request`, "", true)
      }
    }     

    this.props.setLoader(true, "Sending Request..." , false)
    this.props.VDAsendCommand( "setLightCtrlScene", "light" + id, id, this.props.zoneId, this.props.guestDetail, statusCallback, this.props.zoneId);
    this.setState({currentLightscene:`${lightScreen.idKey}`});
    console.log("id", `${lightScreen.idKey}`);
  }

  componentWillUnmount(){
    removeScrollDown();
    clearConfig(this.props.menuColor);

    // Send Analytics
    if(this.props.guestIsLoggedIn){
      let widgetCloseTime = new Date

      let duration = calculateTimeDifference(this.state.widgetLaunchTime, widgetCloseTime, 'second');
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          this.props.guestDetail, 
          this.state.widgetName, 
          EXIT, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
          0, 
          this.props.guestIsLoggedIn
      );
    }

  }

  componentDidMount(){
    if(!this.props.guestIsLoggedIn) return
    window.scrollTo(0,0);
    scrollUpEffect("div.customOverlay",this.props.menuColor);

    // Send Analytics
    if(this.props.guestIsLoggedIn){
      let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
      this.props.sendAnalytics(
          this.props.guestDetail, 
          this.props.currentWidget.displayName, 
          CLICKED, 
          {...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"}, 
          0, 
          this.props.guestIsLoggedIn
      );
    }
  }

  render() {
    console.log("gggggggg",this.props.roomControlResponse);
    

    scrollDownEffect(null,"section",this.props.menuColor,3.6)
    console.log('this.props.menuColor',this.props.menuColor)
    return (
      <div className="main-container "
          style = {{
            height: "100vh",backgroundSize:"cover",backgroundPosition:"center", backgroundAttachment:"fixed"
          }}
        >
          <header id = "header" className="inner-pages subpages no-background" style = {{background: this.props.menuColor.assetBackgroundSelectorColor, boxShadow:"unset",border:"none", position: "sticky"}}>{/*,position:"sticky" */}
            <div className = "customOverlay" style = {{transition:"0.3s", position:"absolute",top:"0", left:"0", width: "100%", height:"85px", zIndex:"-1", background:"transparent"}}></div>
            <a onClick={this.goBack}
              className="button-back"></a>
            <div className="heading align-center">
              <div class="splash-brand">
                  <img src={`${CMSPath}${this.props.logo}`} />
              </div>
            </div>
          </header>
            <section id="customizeRoom" className="widgets padding-bottom-2 margin-0" style = {{paddingTop: "0"}}>

                <div class="widget-header widget-header-checkin">
                    { this.props.currentWidget.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{this.props.currentWidget.displayName}</div>
                </div>

              <div className="widgets">
                {this.props.lightScene && this.props.lightScene.length >= 1 ?
                  <div className="row">
                    <div className="col">
                      <p className="heading" style={{color: this.props.menuColor.assetFontColor}}>Light Scene</p>
                    </div>
                  </div> : null}
                {this.props.lightScene && this.props.lightScene.length >= 1 ?
                  <div className="row">
                    <div className="col col-2 menu-items">
                      {this.props.lightScene.map((iterator, lightIndex) => {
                        if (lightIndex < this.props.lightScene.length) {
                          return (
                            <a
                              onClick={() => {
                                this.selectLightScene(`${iterator.idKey}`,
                                  "lightMood", iterator)
                              }}
                              className=
                                "tile-sm thumbnails tile-container">
                              <div className="thumb-img">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.9 25.9"><title>Day</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle className="cls-1" cx="12.95" cy="12.95" r="7.56" /><polygon className="cls-1" points="11 3.86 12.95 0 14.9 3.86 11 3.86" /><polygon className="cls-1" points="11 22.04 12.95 25.9 14.9 22.04 11 22.04" /><polygon className="cls-1" points="18 5.15 22.11 3.79 20.75 7.9 18 5.15" /><polygon className="cls-1" points="5.15 18 3.79 22.11 7.9 20.75 5.15 18" /><polygon className="cls-1" points="22.04 11 25.9 12.95 22.04 14.9 22.04 11" /><polygon className="cls-1" points="3.86 11 0 12.95 3.86 14.9 3.86 11" /><polygon className="cls-1" points="20.75 18 22.11 22.11 18 20.75 20.75 18" /><polygon className="cls-1" points="7.9 5.15 3.79 3.79 5.15 7.9 7.9 5.15" /></g></g></svg>
                              </div>
                              <div className="thumb-text align-center" style={{ color: "inherit" }}>
                                <p className="thumb-heading" style={{ color: "inherit" }}>{iterator.label}</p>
                                 <button>{<PowerIcon/>}</button>
                              </div>
                            </a>
                          )
                        }
                      })
                      }
                    </div>
                  </div>
                  : null}
              </div>              
            </section>
            { 
            !this.props.RoomControlData.configs && <Loader msg="Fetching data" />
            }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    guestDetail: state.store.home.guestDetails,
    currentWidget: state.store.sideNavBar.currentWidget,
    logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    menuColor: state.store.home.MenuColor,
    lightScene: state.store.VDARoomControl.lightScene,
    RoomControlData: state.store.VDARoomControl.RoomControlData,
    zoneId: state.store.VDARoomControl.zoneId,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
  }
}
export default connect(
  mapStateToProps,
  {
    VDAsendCommand,
    sendAnalytics,
    setFailScreen,
    setGoHome,
    setLoader,
    closeOrderPopUp
  }
)(RoomTheme);